import axios from "axios";
import userService from "../services/user.service";

export default {

  getQuery(option, headers){
    return axios.get(`/${option}`, {headers});
  },

  getInfoPlantas(option, headers){
    return axios.get(`/${option}`, {headers});
  },

 async getQuerys(option, headers){
   //8console.log(option)
    let result = await axios.get(`/${option}`, {headers});
  //console.log(result)
    return result
  },

  editQuery(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/update_qry`, payload, {headers} );
  },

  changeQuery(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/change_qry`, payload, {headers} );
  },
  deleteQuery(payload,token){
    return axios.delete(`/delete_qry`, {
        data: {
          id:payload.id
        },
        headers: {
          Authorization: token 
        } 
      });
  },

  getDeptos(city) {
    return axios.get(`/${city}`);
  },

  getWeek(payload) {
   
    let token = localStorage.getItem('min')
    
    let  headers = {
      Authorization: token
    }
    return axios.post(`/getweek`, payload, {headers});
    
  },
  getDeptoInfo(depto, city, code) {
    let token = userService.getToken() 
    
    let payload = userService.encode(token)
  
    let headers =  {'Authorization': payload} ;
    return axios.get(`/${city}/${depto}/calculator/${code}` );
  },
  getDashboardInfo(depto, city) {
    return axios.get(`/${city}/${depto}/calculator`);
  },
  getBDInfo(depto, city) {
    return axios.get(`/${city}/${depto}`);
  },
  editInfo(base, dias_sucios, extra_m3, depto, city){
    return axios.put(`/${city}/admin/${depto}`,{
        base: base,
        dias_sucios: dias_sucios,
        extra_m3: extra_m3
    });
  },
  editMontoBase(monto_base, depto, city){
    return axios.put(`/${city}/admin/${depto}`,{
        monto: monto_base
    });
  },
  editMontoBaseII(monto_base, depto, city){
    return axios.put(`/${city}/admin/${depto}/edit/monto`,{
        monto: monto_base
    });
  },
  getBonos(depto,city) {
    return axios.get(`/${city}/${depto}/bonos`);
   },
  getProduccion(depto,city){
   return axios.get(`/${city}/${depto}/produccion`);
  },
  getProduccionColab(num){
    return axios.get(`/colab-produccion/${num}`);
   },
   getBonosColab(num){
    return axios.get(`/colab-bonos/${num}`);
   },
  login(user, headers){
    return axios.post('/login', user, headers);
  },
  resendCode(user, headers){
    return axios.post('/reenviar-codigo', user, headers);
  },
  sendPass(num, headers){
   
    return axios.post('/sendpass',num, headers);
  },
  sendSurvey(user, headers){
    return axios.post('/enviar-encuesta', user, headers);
  },
  sendSurveyEmail(user, headers){
    return axios.post('/enviar-encuesta-email', user, headers);
  },
  getReportData(){
    return axios.get('/get/colab-bonos/csv/');
  }

};